<template>
  <div>
    <v-dialog
        v-model="dialog"
        persistent
        width="400"
        scrollable
    >

      <v-card>

        <v-card-title>
          Filtrer par
          <v-spacer/>
          <v-icon @click="close">mdi-close</v-icon>
        </v-card-title>

        <v-divider/>

        <v-card-text class="pa-4">

          <v-radio-group v-model="is_used" label="Status">
            <v-radio label="Utilisé" value="true"></v-radio>
            <v-radio label="Non utilisé" value="false"></v-radio>
          </v-radio-group>

          <v-dialog
              ref="dialog"
              v-model="modal"
              persistent
              width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field outlined
                            dense
                            @click:clear="dates = []"
                            v-model="dateRangeText"
                            readonly
                            append-icon="mdi-calendar-outline"
                            clearable
                            label="Dates..."
                            v-bind="attrs"
                            v-on="on"
              ></v-text-field>
            </template>

            <v-date-picker v-model="dates" scrollable range>
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="modal = false">
                Fermer
              </v-btn>
              <v-btn text
                     color="primary"
                     :disabled="dates.length < 2"
                     @click="modal = false">
                ok
              </v-btn>
            </v-date-picker>
          </v-dialog>

        </v-card-text>


        <v-divider/>

        <v-card-actions>
          <v-btn color="primary"
                 @click="handleFilter"
                 :disabled="dates.length < 2  && !is_used"
                 depressed block
                 type="submit">
            <v-icon left>mdi-magnify</v-icon>
            Rechercher
          </v-btn>
        </v-card-actions>

      </v-card>


    </v-dialog>

  </div>
</template>

<script>

export default {
  data() {
    return {
      isLoading: false,
      isDBLoading: false,
      modal: false,
      dialog: false,
      is_used: null,
      dates: [],
    }
  },
  methods: {
    open() {
      this.dates = []
      this.is_used = null
      this.dialog = true
    },
    close() {
      this.dialog = false
    },
    handleFilter() {
      let data = {
        dates: this.dates,
        is_used: this.is_used,
      }
      this.$emit('filter', data)
      this.close()
    },
  },
  computed: {
    dateRangeText: {
      get() {
        return this.dates.join(' ~ ')
      },
      set(dates) {
        return dates
      }
    }
  },
}
</script>

